import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

const StIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
`

export { StIcon }
